export default __webpack_public_path__ + "static/media/seminario.3be3c305.svg";